import {
  Button,
  Stack,
  Box,
  Slide,
  Slider,
  styled,
  ClickAwayListener,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { tease } from "../components/CheckButton";
import {
  AccountType,
  ButtonStyle,
  Color,
  ContactType,
  ErrorCode,
  FontStyle,
  JobDisplays,
  navPaddingTop,
  QuestionData,
  Slug,
  SurveyButtonStyle,
  SurveyColumn,
} from "../constants";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { StyledTextField } from "../components/AutocompleteUtils";
import { useDispatch, useSelector } from "react-redux";
import { stringEquals } from "../utils/utils";
import SettingsSort from "../components/SettingsSort";
import EmailSlider from "../components/EmailSlider";
import * as apiService from "../service/ApiService";
import { useNavigate } from "react-router-dom";
import { logout } from "../service/AuthService";
import FettiRadio from "../components/FettiRadio";
import { jobIdFromUrl } from "../utils/utils";
import BasicApply from "../components/ApplyPanels/BasicApply";
import FettiProgressBar from "../components/FettiProgressBar";
import { updateApplyData } from "../utils/actionUtils";
import ResumeApply from "../components/ApplyPanels/ResumeApply";
import QuestionsApply from "../components/ApplyPanels/QuestionsApply";
import ReviewApply from "../components/ApplyPanels/ReviewApply";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
  },
  container: {
    // marginTop: '67px',
    paddingTop: "3rem",
    paddingBottom: "110px",
    px: 4,
    backgroundColor: "#fff",
    // backgroundColor: "red",
    height: "100%",
    // alignItems: "stretch",
    minHeight: "calc(100vh - 67px)",
    width: "100%",
    textAlign: "center",
  },
};
const GoogleDriveDisclosure = () => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{
        ...styles.outer,
      }}>
      <Stack
        sx={styles.container}
        direction="column"
        alignItems="center"
        spacing={3}>
        {/* <Stack sx={styles.panel} spacing={2}> */}
        <Box
          sx={{
            width: "100%",
            textAlign: "left",
            ...FontStyle.headingBody,
            maxWidth: "700px",
            fontSize: { xs: "24px", md: "32px" },
          }}>
          Fetti's Use of Google's API
        </Box>
        <Box
          sx={{
            width: "100%",
            ...FontStyle.body,
            fontSize: "16px",
            textAlign: "left",
            color: "#555",
            maxWidth: "700px",
          }}>
          Fetti uses Google's Application Programming Interface (API) Services
          to enable the user authorization feature for accessing the Fetti
          platform. (i.e. use of your Gmail account to login to Fetti platform),
          and to enable the user to upload their resume from Google Drive.
        </Box>
        <Box
          sx={{
            width: "100%",
            ...FontStyle.body,
            fontSize: "16px",
            textAlign: "left",
            color: "#555",
            maxWidth: "700px",
          }}>
          Fetti's use and transfer of information received from Google APIs to
          any other app will adhere to{" "}
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
            target="_blank">
            Google API Services User Data Policy
          </a>
          , including the Limited Use requirements.
        </Box>
      </Stack>
    </Stack>
  );
};

export default GoogleDriveDisclosure;
